var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._g({ref:"button",tag:"component",staticClass:"button",class:[
    _vm.colorClass,
    _vm.heightClass,
    _vm.fontSizeClass,
    {
      'button--loading': _vm.isSubmitting,
      'button--text': _vm.isText,
      'button--inactive': _vm.isInactive,
    } ],attrs:{"disabled":_vm.isDeactivated}},_vm.$listeners),[_c('span',{class:[
      'button__inner',
      { 'button__inner--transparent': _vm.isSubmitting || _vm.isHidingButtonText } ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }